import { useState } from 'react';

const useCustomHook = () => {
  const [data, setData] = useState({
    bizs: [],
    guilds: [],
    products: [],
  });
  const [loading, setLoading] = useState(false);

  return {
    data,
    setData,
    loading,
    setLoading,
  };
};

export default useCustomHook;
